import { render, staticRenderFns } from "./StudentAdminForm.vue?vue&type=template&id=51fe4d88&scoped=true&"
import script from "./StudentAdminForm.vue?vue&type=script&lang=ts&"
export * from "./StudentAdminForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentAdminForm.vue?vue&type=style&index=0&id=51fe4d88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe4d88",
  null
  
)

export default component.exports